"use strict";

(self.webpackChunkuklash = self.webpackChunkuklash || []).push([ [ 758 ], {
  758: function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
    __webpack_require__.r(__webpack_exports__), __webpack_exports__.default = void (customElements.get("vanilla-slider") || customElements.define("vanilla-slider", class extends HTMLElement {
      index=0;
      slider=this.querySelector("[data-slider]");
      slides=this.slider.querySelectorAll("[data-slide]");
      prev=this.querySelectorAll("[data-prev]");
      next=this.querySelectorAll("[data-next]");
      nav=this.querySelector("[data-nav]");
      link=this.querySelector("[data-link]");
      autoplay=1e3 * this.dataset.autoplay || 0;
      thumbnails=this.hasAttribute("data-thumbnails");
      item=this.hasAttribute("data-item");
      progress=this.querySelector("[data-progress]");
      dots=[];
      timeout;
      scroll(direction, event = !1) {
        event && (event.preventDefault(), event.stopPropagation());
        let width = this.slides[0].offsetWidth, position = this.slider.scrollLeft;
        this.slider.scrollTo({
          left: "left" == direction ? position - width : position + width,
          behavior: "smooth"
        });
      }
      goTo(index) {
        let width = this.slides[0].clientWidth;
        this.slider.scrollTo({
          left: width * parseInt(index),
          behavior: "smooth"
        });
      }
      hideArrow=el => {
        el.classList.add(el.hasAttribute("data-hide") ? "opacity-0" : `opacity-${this.opacity}`), 
        el.classList.add("pointer-events-none"), el.classList.remove("pointer-events-auto");
      };
      showArrow=el => {
        el.classList.remove(el.hasAttribute("data-hide") ? "opacity-0" : `opacity-${this.opacity}`), 
        el.classList.remove("pointer-events-none"), el.classList.add("pointer-events-auto");
      };
      updateIndex() {
        this.autoplay && clearTimeout(this.timeout);
        var active = this.index, width = this.thumbnails || this.item ? this.slider.clientWidth + 1 : window.innerWidth + 1;
        if (this.slider.scrollLeft <= 0) active = 0; else if (this.slider.scrollLeft + width >= this.slider.scrollWidth) active = this.slides.length - 1; else if (this.item) for (var i = 0, total = this.slides.length; i < total; i++) this.slides[i].offsetLeft - 5 <= this.slider.scrollLeft && (active = i); else for (i = 0, 
        total = this.slides.length; i < total; i++) this.slides[i].getBoundingClientRect().x > -5 && this.slides[i].getBoundingClientRect().right < width && (active = i);
        this.index = active, this.autoplay && (this.timeout = setTimeout((() => this.goTo(this.index + 1 > this.slides.length - 1 ? 0 : this.index + 1)), this.autoplay));
      }
      updateArrows() {
        setTimeout((() => {
          this.slider.scrollLeft > 0 ? this.prev.forEach(this.showArrow) : this.prev.forEach(this.hideArrow), 
          this.slider.scrollLeft + this.slider.offsetWidth < this.slider.scrollWidth - parseInt(getComputedStyle(document.documentElement).getPropertyValue("--spacing-offset")) ? this.next.forEach(this.showArrow) : this.next.forEach(this.hideArrow);
        }), 100);
      }
      updateNav() {
        this.dots.forEach(((dot, index) => {
          this.thumbnails ? index === this.index ? (dot.classList.remove("border-transparent"), 
          dot.classList.add("border-current")) : (dot.classList.add("border-transparent"), 
          dot.classList.remove("border-current")) : this.hasAttribute("data-delay") ? index === this.index ? (dot.classList.remove("[&>span]:duration-300", "justify-end"), 
          dot.classList.add("[&>span]:w-full")) : (dot.classList.add("[&>span]:duration-300", "justify-end"), 
          dot.classList.remove("[&>span]:w-full")) : index === this.index ? dot.classList.add("bg-current") : dot.classList.remove("bg-current");
        }));
      }
      updateProgress(x = this.slider.scrollLeft) {
        const progress = Math.min(1, x / (this.slider.scrollWidth - this.slider.clientWidth)) || 0;
        this.style.setProperty("--progress-decimal", progress), this.style.setProperty("--progress", 100 * progress + "%");
      }
      update() {
        this.updateIndex(), this.updateArrows(), this.updateNav(), this.updateProgress();
      }
      constructor() {
        super();
      }
      connectedCallback() {
        this.opacity = this.dataset.opacity || 0, this.prev.forEach((el => el.addEventListener("click", (event => this.scroll("left", event))))), 
        this.next.forEach((el => el.addEventListener("click", (event => this.scroll("right", event))))), 
        this.nav && (this.dots = this.nav.querySelectorAll("button"), this.dots.forEach(((dot, index) => {
          dot.addEventListener("click", (() => this.goTo(index)));
        }))), this.update(), this.querySelectorAll("[data-slider]").forEach((slider => slider.addEventListener("scroll", (() => this.update())))), 
        this.progress && (this.progress.style.setProperty("--items", this.slides.length), 
        this.progress.addEventListener("click", (event => {
          try {
            this.goTo(Math.round((this.slides.length - Math.floor(this.slider.clientWidth / this.slides[0].clientWidth)) * (event.layerX / event.target.clientWidth)));
          } catch (e) {
            console.warn("Progress click error: " + e);
          }
        })));
      }
    }));
  }
} ]);